// Components
import MDBox from '../../../../components/MDComponents/MDBox'
import MDTypography from '../../../../components/MDComponents/MDTypography'
import Button from '../../../../components/Button'

export default function PaymentCard({
  name,
  description,
  price,
  interval,
  oldPrice,
  price_id,
  subscriptionsInfo,
  createSubscription,
  cancelSubscription,
  continueSubscription,
  oneTime,
  disabled,
}) {
  const isActive =
    subscriptionsInfo && subscriptionsInfo[price_id]
      ? subscriptionsInfo[price_id].active
      : false
  const isOverdue =
    subscriptionsInfo && subscriptionsInfo[price_id]
      ? subscriptionsInfo[price_id].overdue === true
      : false
  const isCustom =
    subscriptionsInfo && subscriptionsInfo[price_id]
      ? subscriptionsInfo[price_id].custom
      : false
  const isCancelling =
    subscriptionsInfo && subscriptionsInfo[price_id]
      ? subscriptionsInfo[price_id].cancelling
      : false
  const isStarting =
    subscriptionsInfo && subscriptionsInfo[price_id]
      ? subscriptionsInfo[price_id].starting
      : false
  const subscriptionId =
    subscriptionsInfo && subscriptionsInfo[price_id]
      ? subscriptionsInfo[price_id].id
      : false
  const isAnotherStarting =
    subscriptionsInfo &&
    Object.entries(subscriptionsInfo).filter(
      ([price, sub]) => price !== price_id && sub.starting,
    ).length > 0

  const hasNotification = isActive || isOverdue || isCancelling || isStarting

  const twoDigits = number => {
    if (number > 9) {
      return number
    }
    return `0${number}`
  }

  const toDate = timestamp => {
    const date = new Date(timestamp * 1000)
    const current = new Date()

    if (date.getTime() - current.getTime() > 2 * 86400 * 1000) {
      return `pe ${twoDigits(date.getDate())}/${twoDigits(
        date.getMonth() + 1,
      )}/${date.getFullYear()}`
    }

    if (date.getTime() - current.getTime() > 86400 * 1000) {
      return `mâine, ${twoDigits(date.getHours())}:${twoDigits(
        date.getMinutes(),
      )}`
    }

    return `astăzi, ${twoDigits(date.getHours())}:${twoDigits(
      date.getMinutes(),
    )}`
  }

  const getExpireTime = isCustom
    ? `Până ${toDate(subscriptionsInfo[price_id]['expire'])}`
    : isOverdue
      ? 'Reînnoirea automată a eșuat'
      : isActive && 'renew' in subscriptionsInfo[price_id]
        ? `Se reînnoiește ${toDate(subscriptionsInfo[price_id]['renew'])}`
        : ''

  const getTimeString = timestamp => {
    const currentDate = new Date()
    const currentTimestamp = currentDate.getTime() / 1000
    const timeRemaining = timestamp - currentTimestamp

    if (timeRemaining > 20 * 24 * 60 * 60) {
      return `${Math.floor(timeRemaining / 86400)} de zile`
    } else if (timeRemaining > 2 * 24 * 60 * 60) {
      return `${Math.floor(timeRemaining / 86400)} zile`
    } else if (timeRemaining > 24 * 60 * 60) {
      return 'o zi'
    } else if (timeRemaining > 20 * 3600) {
      return `${Math.floor(timeRemaining / 3600)} de ore`
    } else if (timeRemaining > 2 * 3600) {
      return `${Math.floor(timeRemaining / 3600)} ore`
    } else if (timeRemaining > 3600) {
      return 'o oră'
    } else if (timeRemaining > 20 * 60) {
      return `${Math.floor(timeRemaining / 60)} de minute`
    } else if (timeRemaining > 2 * 60) {
      return `${Math.floor(timeRemaining / 60)} minute`
    } else if (timeRemaining > 60) {
      return 'un minut'
    }

    return timeRemaining + ' secunde'
  }

  return (
    <div className="w-[300px] h-[fit-content] ml-auto mr-auto line leading-[1.625] relative">
      <MDBox
        style={{
          background:
            isCancelling || isOverdue
              ? 'rgb(var(--error))'
              : isActive || isStarting
                ? 'rgb(var(--primary))'
                : 'gray',
          borderRadius: '20px 20px 0px 0px',
        }}
      >
        {isCancelling ? (
          <div className="text-center text-white pt-3 pb-3 text-lg font-bold">
            Se termină în {getTimeString(isCancelling)}
          </div>
        ) : isOverdue ? (
          <>
            <MDTypography pt={1} textAlign="center" variant="h6">
              {' '}
              EXPIRAT
            </MDTypography>
            <div className="text-center pb-3 text-lg">{getExpireTime}</div>
          </>
        ) : isActive ? (
          <>
            <div className="text-center text-white pt-3 text-lg font-bold">
              ACTIV
            </div>
            <div className="text-center text-white pb-3 text-lg font-bold">
              {getExpireTime}
            </div>
          </>
        ) : isStarting ? (
          <MDTypography p={1} textAlign="center" variant="h5">
            Începe în {getTimeString(isStarting)}
          </MDTypography>
        ) : (
          <></>
        )}
      </MDBox>

      <div
        className={`bg-[rgb(var(--secondary-background))] h-[270px] rounded-b ${
          hasNotification ? 'rounded-t-0' : 'rounded-t'
        } p-6 font-medium shadow-lg`}
      >
        {/* Title */}
        <h1 className="text-3xl text-left text-over-secondary-background">
          {isCustom ? 'Special' : name}
        </h1>

        {/* Description  */}
        <p className="text-sm text-left font-normal	text-over-secondary-background opacity-75">
          {isCustom ? 'Tip de abonament creat special' : description}
        </p>

        {/* Pricing */}

        <div className="text-over-secondary-background font-bold text-sm mt-7">
          {!isCustom && oldPrice && (
            <div className="opacity-20 line-through">{oldPrice + ' RON'}</div>
          )}

          <p className="text-4xl text-primary">
            {price === 0 || isCustom
              ? 'Gratuit'
              : +(price / interval).toFixed(2) + ' RON'}
            {price !== 0 && !isCustom ? (
              <span className="text-sm ml-2 font-normal">pe lună</span>
            ) : (
              <></>
            )}
          </p>
          <span className="text-sm font-light text-primary">
            {!isCustom &&
              (oneTime
                ? `(plătit o singură dată - total ${price} RON)`
                : interval &&
                  interval !== 1 &&
                  `(plătit ${interval} luni în avans - total ${price} RON)`)}
          </span>
        </div>

        {/* Button */}
        {!isCustom && (
          <MDBox ml="auto" mr="auto">
            {price === 0 || isAnotherStarting ? (
              <></>
            ) : !oneTime && isOverdue ? (
              <Button
                className="bg-error w-[70%] absolute bottom-6"
                onClick={() => cancelSubscription(subscriptionId)}
              >
                Anulează
              </Button>
            ) : !oneTime && isCancelling ? (
              <Button
                className="bg-primary w-[70%] absolute bottom-6"
                onClick={() => continueSubscription(subscriptionId)}
              >
                Continuă abonamentul
              </Button>
            ) : !oneTime && isActive ? (
              <Button
                className="bg-error w-[70%] absolute bottom-6"
                onClick={() => cancelSubscription(subscriptionId)}
              >
                Anulează
              </Button>
            ) : !oneTime && isStarting ? (
              <Button
                className="bg-error w-[70%] absolute bottom-6"
                onClick={() => cancelSubscription(subscriptionId)}
              >
                Anulează
              </Button>
            ) : (
              <Button
                className="bg-primary w-[70%] absolute bottom-6"
                onClick={() =>
                  createSubscription(price_id, price * 100, oneTime === true)
                }
                disabled={disabled === true || (oneTime && isActive)}
              >
                Cumpără
              </Button>
            )}
          </MDBox>
        )}
      </div>
    </div>
  )
}
